import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
import { fallbackLng, languages, defaultNS, cookieName } from '@/i18next.config';

// Store the initialization promise for waiting
let initPromise: Promise<typeof i18next> | null = null;

// Initialize i18next and return a promise that resolves with the i18n instance
function initI18next(): Promise<typeof i18next> {
  if (initPromise) return initPromise;
  
  if (i18next.isInitialized) {
    return Promise.resolve(i18next);
  }

  initPromise = i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(resourcesToBackend((language: string, namespace: string) => {
      const lang = language.split('-')[0];
      return import(`../../locales/${lang}/${namespace}.json`);
    }))
    .init({
      supportedLngs: languages,
      fallbackLng,
      lng: undefined,
      fallbackNS: defaultNS,
      defaultNS,
      detection: {
        order: ['cookie', 'navigator', 'htmlTag'],
        caches: ['cookie'],
        lookupCookie: cookieName,
      },
      react: {
        useSuspense: false,
      },
    })
    .then(() => i18next);
    
  return initPromise;
}

// Auto-initialize when module loads in browser
if (typeof window !== 'undefined') {
  initI18next();
}

export { initI18next };
export default i18next;